<!--
 * @Description: (弹框)商户表单组件
 * @Author: sunhuihong
 * @Date: 2022-09-29 16:43:52
 * @LastEditTime: 2022-11-08 14:46:50
-->
<template>
  <div class="body">
    <el-drawer title="申请收付通商户" :before-close="handleClose" :visible.sync="visible" direction="rtl" 
      size="1000px" ref="drawer" withHeader :wrapperClosable="wrapperClosable" @open="initData">
      <div class="mch-apply-form-header">
        <span style="color: #E9A338; font-size: 14px;"><i class="el-icon-info"></i></span>
        <span style="color: #606266; font-size: 12px; margin-left: 2px;">{{alertTitle}}</span>
      </div>
      <common-mch-form ref="mchForm" @close-drawer="handleCloseDrawer" />
    </el-drawer>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import CommonMchForm from './CommonMchForm.vue'
import mchStore from './MchStore'

export default {
  name: 'MchApplyForm',
  props: ["visible", "mode","instId"],
  components: {
    'common-mch-form': CommonMchForm,
  },
  mchStore,
  data() {
    return {
      wrapperClosable: true,
      alertTitle: '平台已开通电商收付通，请在此处提交相应资料，审核完成后，订单收款到您账户，可进行自动分账',
    }
  },
  
  methods: {
    async initData() {
      //以下代码编辑收付通商户可参考
			mchStore.commit("changeMode", this.mode);
			let mchFormData = await this.queryData();
			mchStore.commit('changeMchFormData', mchFormData);
      
      //新增收付通商户表单默认数据(如果是编辑参照以下写法 : mchStore.commit('changeCommonMchForm', defaultAddCommonMchForm) )
      //defaultAddCommonMchForm 对象里面 必须包含{bankAccount : {} , merchant : {}} 直接取后端返回数据里面 Merchant实体 和 BankAccount实体
      let defaultAddCommonMchForm = {
        bankAccount : {institutionId: this.instId == 0 ? '' : this.instId, type: 1},
        merchant : {idCardType: 1, type: 1, isOwner: 1, superAdminType: 1, idCardValidtyLongTerm: 0,
          institutionId: this.instId == 0 ? '' : this.instId}
      }
      mchStore.commit('changeCommonMchForm', defaultAddCommonMchForm);
    },

    queryData() {
      return new Promise((resolve) => {
        let url = Constant.URL_GET_MERCHANT_DO_4_ADD;
				this.appAxios("GET", url).then(result => {
					if (result != null) {
						resolve(result.data);
					}
				})
			})
    },
    
    //关闭申请收付通商户表单抽屉
    handleClose() {
      this.clearData();
      this.$emit("close-drawer", false);
    },

    handleCloseDrawer(refresh) {
      if (refresh) {
        this.handleSubmitFormData();
      } else {
        this.clearData();
        this.$emit("close-drawer", refresh);
      }
    },

    handleSubmitFormData() {
			let url = Constant.URL_SAVE_MERCHANT
			let formParam = new FormData();
			if (mchStore.state.bizLicenseFile && mchStore.state.bizLicenseFile.raw) {
        formParam.append('bizLicenseFile', mchStore.state.bizLicenseFile.raw)
      }
			if (mchStore.state.idCardImg1File && mchStore.state.idCardImg1File.raw) {
        formParam.append('idCardImg1File', mchStore.state.idCardImg1File.raw)
      }
			if (mchStore.state.idCardImg2File && mchStore.state.idCardImg2File.raw) {
        formParam.append('idCardImg2File', mchStore.state.idCardImg2File.raw)
      }
      let obj = mchStore.state.commonMchForm;
			formParam.append('merchantVO', new Blob([JSON.stringify(obj)], {
				type: this.commonConst.CNTYPE_JSON
			}));
      console.log(obj)
			this.appAxios('POST', url, formParam, this.commonConst.CNTYPE_FORM_DATA).then(result => {
				if (result == null) {
          return;
				}
				this.clearData();
        this.$emit("close-drawer", {mchId : result.data.id, instId : result.data.institutionId, refresh : true });
			})
    },

    clearData() {
      this.$refs.mchForm.$refs.commonMchForm.clearValidate();
      mchStore.commit('changeCommonMchForm', {bankAccount : {},merchant : {}});
			mchStore.commit('changeBizLicenseFile', null);
			mchStore.commit('changeIdCardImg1File', null);
			mchStore.commit('changeIdCardImg2Path', null);
      mchStore.commit('changeSrcProvinceList', []);
			mchStore.commit('changeSrcCityList', []);
			mchStore.commit('changeSrcBranchesList', []);
    },
  },  
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: left;
  border: solid 0px;
}

.mch-apply-form-header {
  padding-left: 24px;
  height: 38px;
  line-height: 38px;
  margin-top: 9px;
  background: #F7F9FE;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/mchmng/components/MchApplyForm.vue